$("body.route-apam_informa").on("click", ".load-others", function(e) {

    e.preventDefault();

    $.get(Routing.generate("apam_informa_ajax_list", {
        "page": $(this).attr("data-page"),
        "route": $("#apam-informa-routes-filter").val(),
        "_": $.now()
    }), function(data) {

        $("body.route-apam_informa").find(".load-others").parent().parent().parent().remove();
        $("#apam-informa-data").find(".container").append(data);
    });
});
$("body.route-apam_informa").on("change", "#apam-informa-routes-filter", function() {

    $.get(Routing.generate("apam_informa_ajax_list", {
        "page": 0,
        "route": $("#apam-informa-routes-filter").val(),
        "_": $.now()
    }), function(data) {

        $("#apam-informa-data").find(".container").html(data);
    });
});